var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddviewplannericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9625 19.6879L23.1875 28.0004H28V23.2754L19.775 14.9629C18.4625 13.6504 16.3625 13.6504 15.05 14.9629C13.65 16.2754 13.65 18.3754 14.9625 19.6879ZM20.125 17.8504L26.25 23.9754V26.2504H23.975L17.85 20.1254L20.125 17.8504ZM16.1875 16.1879C16.8 15.5754 17.85 15.5754 18.4625 16.1879L18.9 16.6254L16.625 18.9004L16.1875 18.4629C15.575 17.8504 15.575 16.8879 16.1875 16.1879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 26.25H0V28H12.25V26.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 0H21.875V1.75H17.7625V0H16.0125V1.75H11.9V0H10.15V1.75H6.125V0H4.375V1.75H0V24.5H12.25V22.75H1.75V8.75H26.25V12.25H28V1.75H23.625V0ZM26.25 3.5V7H1.75V3.5H4.375V5.25H6.125V3.5H10.2375V5.25H11.9875V3.5H16.1V5.25H17.85V3.5H21.875V5.25H23.625V3.5H26.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 11.375H14.875V13.125H16.625V11.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 11.375H18.375V13.125H20.125V11.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.375H21.875V13.125H23.625V11.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 14.875H4.375V16.625H6.125V14.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 14.875H7.875V16.625H9.625V14.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.875H11.375V16.625H13.125V14.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 18.375H4.375V20.125H6.125V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.375H7.875V20.125H9.625V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 18.375H11.375V20.125H13.125V18.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddviewplannericon);
export default __webpack_public_path__ + "static/media/addviewplannericon.b983b1c22596abd616f0e6373462f0e2.svg";
export { ForwardRef as ReactComponent };